/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

/**
 * @module LogsModule
 */

/**
 * @fileoverview Contains Ajs dependency tokens for logs-related components and factories.
 * @author alextsg
 */

export const L4_DATASCRIPT_LOG_COMPONENT_TOKEN = 'l4DatascriptLog';
